import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';

export const DownloadTemplateButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<DescriptionOutlined />} {...props}>
      {children ?? t('DownloadTemplate')}
    </Button>
  );
};
